import React, { Component } from "react"
import { getCustomColors } from "../utils/js/utils"
// eslint-disable-line no-unused-vars

import "./_campaign-banner.scss"

class CampaignBanner extends Component {
  static defaultProps = {
    modifier: "",
    linkUrl: "#",
    text: "Få 10% rabat ved køb for 1.000 DKK.",
    textShort: "Få 10% rabat",
    underlined: "Læs mere",
    backgroundUrl: "/static/newshop/campaignbanner_10sale.png",
    themeClass: "",
    backgroundColor: "",
    backgroundHoverColor: "",
    textColor: "",
    textHoverColor: "",
  }

  render() {
    let style = getCustomColors(this.props)
    if (this.props.backgroundUrl) {
      style.backgroundImage = `url(${this.props.backgroundUrl})`
    }

    return (
      <div className={`campaign-banner ${this.props.modifier} ${this.props.themeClass}`}>
        <a href={this.props.linkUrl} style={style}>
          <p className="d-none d-block--sm">
            {this.props.text} <span>{this.props.underlined}</span>
          </p>
          <p className="d-none--sm">
            {this.props.textShort} <span>{this.props.underlined}</span>
          </p>
        </a>
      </div>
    )
  }
}

export default CampaignBanner
